import React, { Component } from "react";
import {Link} from 'react-router-dom';

class ReloanButton extends Component {
    render() {
      let addDisabledToClasses = this.props.btnClasses + " disabled";

      switch(this.props.disableNext){
        case true:
          return (
            <Link className={addDisabledToClasses} to="/#" >
              <span>{this.props.btnText}</span>
            </Link>
          )
        default:
          return (
            <Link className={this.props.btnClasses} to={this.props.next} tabIndex={this.props.tabIndex} >
              <button type="submit">{this.props.btnText}</button>
            </Link>
          )
      }
    }
}

export default ReloanButton;



// WEBPACK FOOTER //
// ./src/components/partials/ReloanButton.js